import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './FlyOutStorefrontMetricsWrapper.styles'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { LabraToolTipV2 } from '@labrav/react-components'

export type headerAlignmentType = 'normal'
interface FlyOutStorefrontMetricsWrapperProps {
  heading: string
  children: JSX.Element
  icon: IconProp
  infoTooltip: string
  actionLabel?: string | JSX.Element
  handleAction?: () => void
  removeBottomBorder?: boolean
  removeTopBorder?: boolean
  headerAlignment?: headerAlignmentType
  padding?: string
}

export const FlyOutStorefrontMetricsWrapper = ({
  icon,
  heading,
  actionLabel,
  handleAction,
  children,
  infoTooltip,
  removeBottomBorder,
  removeTopBorder,
  headerAlignment,
  padding,
}: FlyOutStorefrontMetricsWrapperProps) => {
  const { classes } = useStyles({
    removeBottomBorder,
    removeTopBorder,
    headerAlignment,
    padding,
  })
  return (
    <div className={classes.root} data-testid={'store-front-metrics-wrapper'}>
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <div className={classes.iconContainer}>
            <FontAwesomeIcon
              icon={icon}
              style={{ width: '18px', height: '14px' }}
            />
          </div>
          <div className={classes.headerTextIcon}>
            <div className={classes.heading}>{heading}</div>
            <div className={classes.infoIcon}>
              <LabraToolTipV2
                tooltipPlacement={'bottom-start'}
                description={infoTooltip}
                tooltipPlacmentGap="12px"
              >
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{
                    height: 16,
                    color: '#6A777A',
                    width: 16,
                    display: 'flex',
                  }}
                />
              </LabraToolTipV2>
            </div>
          </div>
        </div>
        {actionLabel && handleAction && (
          <div className={classes.link} onClick={handleAction}>
            {actionLabel}
          </div>
        )}
      </div>
      {children}
    </div>
  )
}
